import { i18n } from "../i18n"
export const _i18n = () => {
  return i18n.global
}

export const EnumPromotionType = {
  CAMPAIGN: "campaign",  // 滿減滿贈活動
  KOL: "kol",  // 開團
  WHOLESALE: "wholesale",  // 批發
  CYCLE: "cycle",  // 循環購
  DISCOUNT_CODE: "code",  // 折扣碼
  DISTRIBUTE: "distribute",  // 分銷
  DISTRIBUTE_LIMITED: "distribute_limited",  // 分銷限量
  DISTRIBUTE_BUNDLE: "distribute_bundle",  // 分銷任選
  KOL_BUNDLE: "kol_bundle",  // 開團任選
  BUNDLE: "bundle",  // 商店任選
}

export const isBundlePromotionType = (type) => {
  const list = [
    EnumPromotionType.BUNDLE,
    EnumPromotionType.KOL_BUNDLE,
    EnumPromotionType.DISTRIBUTE_BUNDLE,
  ]
  return list.includes(type)
}
export function lookupPromotionTypes() {
  return [
    { label: _i18n().t(`promotions.types.${EnumPromotionType.CAMPAIGN}`), value: EnumPromotionType.CAMPAIGN }, // 滿減滿贈活動
    { label: _i18n().t(`promotions.types.${EnumPromotionType.KOL}`), value: EnumPromotionType.KOL }, // 開團
    { label: _i18n().t(`promotions.types.${EnumPromotionType.CYCLE}`), value: EnumPromotionType.CYCLE }, // 循環購
    { label: _i18n().t(`promotions.types.${EnumPromotionType.DISCOUNT_CODE}`), value: EnumPromotionType.DISCOUNT_CODE }, // 折扣碼
    { label: _i18n().t(`promotions.types.${EnumPromotionType.DISTRIBUTE}`), value: EnumPromotionType.DISTRIBUTE }, // 分銷
    { label: _i18n().t(`promotions.types.${EnumPromotionType.DISTRIBUTE_LIMITED}`), value: EnumPromotionType.DISTRIBUTE_LIMITED }, // 分銷限量
    { label: _i18n().t(`promotions.types.${EnumPromotionType.BUNDLE}`), value: EnumPromotionType.BUNDLE }, // 商店任選
    { label: _i18n().t(`promotions.types.${EnumPromotionType.KOL_BUNDLE}`), value: EnumPromotionType.KOL_BUNDLE }, // 開團任選
    { label: _i18n().t(`promotions.types.${EnumPromotionType.DISTRIBUTE_BUNDLE}`), value: EnumPromotionType.DISTRIBUTE_BUNDLE }, // 分銷任選
  ]
}